export default __webpack_public_path__ + "static/media/snow-icon.bf132558.svg";